import { PartnerListFeatureStatusAction, KalturaFeatureStatusListResponse } from 'kaltura-ngx-client';

import { RequestFactory } from '@kaltura-ng/kaltura-common';

export class CategoriesStatusRequestFactory
implements RequestFactory<PartnerListFeatureStatusAction, KalturaFeatureStatusListResponse> {
  create(): PartnerListFeatureStatusAction {
    return new PartnerListFeatureStatusAction({});
  }
}
